<template>
  <div class="">
    <v-card class="pa-3 fund-description-box">
      <v-card class="fund-description-container" v-if="i18n.locale == 'en'">
        <h2 v-if="$vuetify.breakpoint.mdAndUp" class="h2 red--text">Important Notice</h2>
        <br v-if="$vuetify.breakpoint.mdAndUp" />
        <p class="black--text">
          <span class="font-weight-bold">1. Use Only Official Deposit & Withdrawal Channels</span>
          <br />
          Please ensure that all deposits and withdrawals are made exclusively through the official channels listed on our website. Refrain from using any third-party or unauthorized platforms.
          <br />
          <br />

          <span class="font-weight-bold">2. Live Chat Support for Delayed Transactions</span>
          <br />
          If your transaction is pending for more than 15 minutes, we encourage you to contact our 24/7 live chat support. Our team is always available to assist and provide real-time updates.
          <br />
          <br />

          <span class="font-weight-bold">3. Caution When Cash Out / Withdrawal</span>
          <br />
          Avoid cashing out directly to any previously used e-wallet. Always follow the current procedures outlined by our platform to ensure the security and proper processing of your transactions.
          <br />
          <br />

          <span class="font-weight-bold">4. Use Only Platform-Provided E-Wallet Numbers</span>
          <br />
          When requesting a cash-out, make sure to use the e-wallet number specifically provided by our platform. This ensures smoother processing and reduces the risk of errors.
          <br />
          <br />

          These guidelines are designed to protect your funds and maintain the integrity of your account. Should you have any questions, our support team is available 24/7 via live chat.
          <br />
        </p>
      </v-card>
      <v-card class="fund-description-container" v-else>
        <h2 v-if="$vuetify.breakpoint.mdAndUp" class="h2 red--text">গুরুত্বপূর্ণ নোটিশ</h2>
        <br v-if="$vuetify.breakpoint.mdAndUp" />
        <p class="black--text">
          <span class="font-weight-bold">১. শুধুমাত্র অফিসিয়াল ডিপোজিট ও উইথড্রয়াল চ্যানেল ব্যবহার করুন</span>
          <br />
          সমস্ত ডিপোজিট ও উইথড্রয়াল শুধুমাত্র আমাদের ওয়েবসাইটে তালিকাভুক্ত অফিসিয়াল চ্যানেলের মাধ্যমে সম্পন্ন করুন। কোনো তৃতীয় পক্ষ বা অনুমোদনহীন প্ল্যাটফর্ম ব্যবহার থেকে বিরত থাকুন।
          <br />
          <br />

          <span class="font-weight-bold">২. বিলম্বিত লেনদেনের জন্য ২৪/৭ লাইভ চ্যাট সাপোর্ট</span>
          <br />
          আপনার লেনদেন যদি ১৫ মিনিটের বেশি সময় অপেক্ষমাণ থাকে, তবে আমাদের KRIKYA ২৪/৭ লাইভ চ্যাট সাপোর্ট টিমের সাথে যোগাযোগ করুন। আমাদের টিম সর্বদা সহায়তা করতে এবং রিয়েল-টাইম আপডেট দিতে প্রস্তুত।
          <br />
          <br />

          <span class="font-weight-bold">৩. সতর্কতা: ক্যাশ আউট / উইথড্রয়ালে</span>
          <br />
          কোনও পূর্বে ব্যবহৃত ই-ওয়ালেটে সরাসরি ক্যাশ আউট করবেন না। সর্বদা আমাদের প্ল্যাটফর্ম দ্বারা নির্ধারিত বর্তমান পদ্ধতি অনুসরণ করুন যাতে আপনার লেনদেনের নিরাপত্তা এবং সঠিক প্রক্রিয়াকরণ নিশ্চিত
          হয়।
          <br />
          <br />

          <span class="font-weight-bold">৪. শুধুমাত্র KRIKYA দ্বারা প্রদত্ত ই-ওয়ালেট নম্বর ব্যবহার করুন</span>
          <br />
          ক্যাশ-আউটের জন্য অনুরোধ করার সময়, অবশ্যই আমাদের প্ল্যাটফর্ম থেকে বিশেষভাবে সরবরাহকৃত ই-ওয়ালেট নম্বর ব্যবহার করুন। এটি প্রক্রিয়াটি আরও সহজ করে এবং ভুলের ঝুঁকি কমায়।
          <br />
          <br />

          এই নির্দেশনা গুলি আপনার অর্থের সুরক্ষা এবং আপনার অ্যাকাউন্টের সঠিকতা বজায় রাখার জন্য ডিজাইন করা হয়েছে। যদি আপনার কোনো প্রশ্ন থাকে, তাহলে আমাদের গ্রাহক সহায়তা দল লাইভ চ্যাটের মাধ্যমে ২৪/৭
          উপলব্ধ।
          <br />
        </p>
      </v-card>
    </v-card>
  </div>
</template>

<script>
import { formValidator, locale, errorCodeHelper, uiHelper } from '@/util'
import i18n from '@/plugins/i18n'
export default {
  name: 'fundSideDescription',
  components: {},
  data: () => ({
    validator: formValidator,
    i18n
  })
}
</script>

<style lang="scss">
.fund-description-box {
  border-radius: 8px;
  background-color: var(--v-background-lighten1) !important;
}
.fund-description-container {
  background: transparent !important;
  font-size: 12px;
  border: none !important;
  box-shadow: none !important;
}
</style>
